<script>
import {defineComponent} from 'vue'
import {Link} from '@inertiajs/vue3'
import NumberFormatComponent from '@js/components/Formatter/NumberFormatComponent.vue'

export default defineComponent({
    name: 'ProductCategoriesLinks',
    components: {Link, NumberFormatComponent},
    props: {
        categories: {type: Array, required: true}
    },
    methods: {
        imgWebp(slug) {
            return `/storage/menu_category_images/${slug}.webp`
        },
        imgJpg(slug) {
            return `/storage/menu_category_images/${slug}.jpg`
        },
        onImgError(e, slug) {
            if (e?.target?.dataset?.fallbackApplied) return
            e.target.dataset.fallbackApplied = '1'
            e.target.src = this.imgJpg(slug)
        }
    }
})
</script>

<template>
    <div class="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-3 md:gap-4 xl:gap-5 mt-6 md:mt-10">
        <Link
            v-for="c in categories"
            :key="c.slug"
            :href="route('catalog', c.slug)"
            class="group relative focus:outline-none"
            :aria-label="`${c.title}: от ${c.min_price} ₽`"
        >
            <article
                class="h-full rounded-2xl overflow-hidden shadow-sm ring-1 ring-black/10
               transition-all duration-200 ease-out
               hover:-translate-y-0.5 hover:shadow-md hover:ring-black/20
               focus-visible:ring-2 focus-visible:ring-baseColor/50">

                <!-- Media -->
                <div class="relative overflow-hidden">
                    <div class="w-full aspect-[4/3]">
                        <img :src="'/storage/menu_category_images/'+c.slug+'.webp'"
                             width="400" height="300"
                             :alt="c.title" class="h-full w-full object-cover"
                             loading="lazy" decoding="async"/>
                    </div>

                    <!-- бейдж количества -->
                    <div
                        class="pointer-events-none absolute left-2 top-2 rounded-full bg-white/90 px-2 py-1.5 text-[11px] font-semibold text-gray-900 shadow-sm leading-tight">
                        {{ c.positions }} товаров
                    </div>

                    <!-- затемнение + title + цена -->
                    <div
                        class="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent p-3">
                        <h3 class="line-clamp-2 text-sm md:text-[15px] font-medium text-white">
                            {{ c.title }}
                        </h3>
                        <div class="flex items-baseline gap-1.5 mt-0.5">
                            <span class="text-xs text-gray-200">от</span>
                            <span class="max-md:text-sm font-bold text-white">
                                <NumberFormatComponent :number="c.min_price" append_text=" ₽"/>
                            </span>
                        </div>
                    </div>
                </div>

                <!-- акцент по краю -->
                <span
                    class="pointer-events-none absolute inset-0 rounded-2xl ring-2 ring-transparent group-hover:ring-baseColor/40 transition"/>
            </article>
        </Link>
    </div>
</template>

<style scoped>
.line-clamp-2 {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
}
</style>
